import SectionLayout from "../layouts/Section";

import ContainerLayout from "../layouts/Container";
import RowLayout from "../layouts/Row";
import ColLayout from "../layouts/Col";

function QuotePage() {
  const quotes = [
    {
      title: "Key Rule",
      description: "LEARN , EARN AND FIGHT",
    },

    {
      title: "Remember",
      description: "Never back down. I can I will",
    },
    {
      title: "Remember",
      description: "There is minor difference between ego and attitude",
    },
    {
      title: "Remember",
      description:
        "First they ignore you Second they insult you thrid they fight with you and then you win",
    },
  ];
  return (
    <>
      <SectionLayout className="contact-section" id="contact">
        <ContainerLayout>
          <RowLayout>
            {quotes.map((card) => {
              return (
                <ColLayout
                  key={card.id}
                  className="col-md-12  contact-card-container"
                >
                  <div className="contact-card-section">
                    <div className="contact-card-main-container">
                      <div className="contact-card-detail-container">
                        <div className="card-title">{card.title}</div>
                        <div className="card-detail grade">
                          {card.description}
                        </div>
                      </div>
                    </div>
                  </div>
                </ColLayout>
              );
            })}
          </RowLayout>
        </ContainerLayout>
      </SectionLayout>
    </>
  );
}

export default QuotePage;
